import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Searchbar from "../../components/Search";
import useApiPost from "../hooks/postData";
import toast from "react-hot-toast";
import Loader from "../../assets/Loader.gif";
import NoData from "../../assets/NoData.png";
import Avatar from "../../assets/Avatar.png";

const headCell = "text-headerText font-poppins text-sm font-semibold";

const STATUS_FILTERS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Expired", value: "expired" },
];

const STATUS_STYLE = {
  active: "text-[#0D9947] bg-[#0D9947] bg-opacity-20",
  cancelled: "text-red-500 bg-red-500 bg-opacity-20",
  expired: "text-[#B7791F] bg-[#B7791F] bg-opacity-20",
};

// API times are UTC; the admin panel shows IST.
const formatIST = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

function UserCell({ user }) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <img
        src={user?.avatar_url || Avatar}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = Avatar;
        }}
        alt=""
        className="object-cover w-8 h-8 rounded-full shrink-0"
      />
      <div className="min-w-0">
        <p className="text-[#000000] dark:text-darkText font-poppins text-sm font-semibold truncate">
          {user?.name || "-"}
        </p>
        <p className="text-[#858585] font-poppins text-xs truncate">
          @{user?.username || user?.user_id}
        </p>
      </div>
    </div>
  );
}

function CpConnections() {
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const { data, postData, loading } = useApiPost();

  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    const payload = { page };
    if (status) payload.status = status;
    postData("/cp-connection/admin-list", payload).catch(() =>
      toast.error("Failed to load connections")
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, page]);

  const connections = data?.connections || [];
  const lastPage = data?.last_page || 1;
  const currentPage = data?.current_page || page;

  const changeStatus = (value) => {
    setStatus(value);
    setPage(1);
  };

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <Searchbar />

      <div className="px-4 pb-10 xl:px-6">
        <div className="flex justify-between border-t-[#F2F2F2] py-3">
          <h2 className="text-[#000000] dark:text-darkText font-poppins text-xl font-semibold pt-3">
            CP Connections
          </h2>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <Link to="/dashboard">
              <h3 className="text-[#3A3A3A] dark:text-darkText font-poppins text-base font-semibold">
                Dashboard
              </h3>
            </Link>
            <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
            <h3 className="text-[#858585] font-poppins text-base">CP Connections</h3>
          </div>

          <div className="flex items-center gap-2">
            {STATUS_FILTERS.map((f) => (
              <button
                key={f.value}
                onClick={() => changeStatus(f.value)}
                className={`px-4 py-1.5 text-sm font-poppins rounded-md ${
                  status === f.value
                    ? "text-white bg-button-gradient"
                    : "bg-[#F2F2F2] dark:bg-[#1F1F1F] dark:text-darkText text-[#000000]"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-8 overflow-x-auto w-full">
          <div className="min-w-[1100px]">
            <div className="flex px-4 py-3 pl-8 text-left border-b dark:border-b-[#1F1F1F] dark:bg-darkHeader bg-header1">
              <div className={`w-[22%] ${headCell}`}>USER 1</div>
              <div className={`w-[22%] ${headCell}`}>USER 2</div>
              <div className={`w-[12%] ${headCell}`}>CATEGORY</div>
              <div className={`w-[10%] ${headCell}`}>COINS SHARED</div>
              <div className={`w-[6%] ${headCell}`}>GIFTS</div>
              <div className={`w-[15%] ${headCell}`}>SINCE (IST)</div>
              <div className={`w-[13%] ${headCell}`}>STATUS</div>
            </div>

            {loading ? (
              <div className="flex justify-center py-32">
                <img src={Loader} alt="loader" height={50} width={50} />
              </div>
            ) : connections.length === 0 ? (
              <div className="flex flex-col justify-center py-32 place-items-center">
                <img src={NoData} alt="no data" className="w-96" />
                <h2 className="font-poppins text-[#000000] dark:text-darkText text-sm font-semibold">
                  No connections found
                </h2>
              </div>
            ) : (
              connections.map((c, index) => (
                <div
                  key={c.id}
                  className={`${
                    index % 2 === 0 ? "bg-white dark:bg-primary" : "bg-[#00162e0a] dark:bg-primary"
                  } flex items-center px-4 py-3 pl-8 border-b dark:border-b-[#1F1F1F] last:border-0`}
                >
                  <div className="w-[22%] pr-2">
                    <UserCell user={c.user1} />
                  </div>
                  <div className="w-[22%] pr-2">
                    <UserCell user={c.user2} />
                  </div>
                  <div className="w-[12%] text-[#000000] dark:text-darkText font-poppins text-sm">
                    {c.category?.emoji} {c.category?.name || "-"}
                    <p className="text-[#858585] text-xs">
                      {c.category?.coin_cost != null
                        ? `${Number(c.category.coin_cost).toLocaleString()} coins`
                        : ""}
                    </p>
                  </div>
                  <div className="w-[10%] text-[#414141] dark:text-tableDarkLarge font-poppins text-sm">
                    {Number(c.total_coins_shared || 0).toLocaleString()}
                  </div>
                  <div className="w-[6%] text-[#414141] dark:text-tableDarkLarge font-poppins text-sm">
                    {c.gift_count ?? 0}
                  </div>
                  <div className="w-[15%] text-[#414141] dark:text-tableDarkLarge font-poppins text-xs">
                    {formatIST(c.started_at)}
                    {c.status === "active" && c.gift_deadline && (
                      <p className="text-[#858585]">Gift by: {formatIST(c.gift_deadline)}</p>
                    )}
                    {c.ended_at && <p className="text-[#858585]">Ended: {formatIST(c.ended_at)}</p>}
                  </div>
                  <div className="w-[13%]">
                    <span
                      className={`px-3 py-1 text-xs font-semibold capitalize rounded-full font-poppins ${
                        STATUS_STYLE[c.status] || "bg-[#F2F2F2] text-[#414141]"
                      }`}
                    >
                      {c.status}
                    </span>
                    {c.status === "active" && (
                      <p className="mt-1 text-xs text-[#858585] font-poppins">
                        {c.gifted_today ? "Gifted today" : "Not gifted today"}
                      </p>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between mt-6">
          <p className="text-sm font-poppins text-[#858585]">
            Total: {data?.total ?? 0}
          </p>
          <div className="flex items-center gap-3">
            <button
              disabled={currentPage <= 1 || loading}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              className="px-4 py-1.5 text-sm font-poppins rounded-md bg-[#F2F2F2] dark:bg-[#1F1F1F] dark:text-darkText disabled:opacity-40"
            >
              Prev
            </button>
            <span className="text-sm font-poppins dark:text-darkText">
              Page {currentPage} / {lastPage}
            </span>
            <button
              disabled={currentPage >= lastPage || loading}
              onClick={() => setPage((p) => p + 1)}
              className="px-4 py-1.5 text-sm font-poppins rounded-md bg-[#F2F2F2] dark:bg-[#1F1F1F] dark:text-darkText disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CpConnections;
